module.exports = __webpack_public_path__ + "img/icon-c-download.5ac46c89.svg";